import type { ReactElement } from 'react';
import { Rectangle } from 'recharts';

/**
 * Num par empilhado, só o segmento de cima arredonda o topo. Quando ele zera (100% de um lado) o segmento
 * de baixo passa a ser o topo da barra e precisa assumir o arredondamento.
 */
export const firstSegmentShape =
  (topKey: string) =>
  // biome-ignore lint/suspicious/noExplicitAny: o recharts não exporta o tipo das props do `shape` da Bar
  (props: any): ReactElement => (
    <Rectangle
      {...props}
      radius={(props.payload as Record<string, unknown> | undefined)?.[topKey] === 0 ? [8, 8, 0, 0] : 0}
    />
  );

/**
 * Rótulo do segmento de baixo: branco, dentro do segmento de cima. Quando o de cima zera não há fundo
 * roxo por trás, então o rótulo vai em cor escura, acima da barra.
 */
export const firstSegmentLabel =
  <T extends object>(data: T[], topKey: keyof T) =>
  // biome-ignore lint/suspicious/noExplicitAny: o recharts não exporta o tipo das props do `content` do LabelList
  ({ x, y, width, value, index }: any): ReactElement => {
    const isTop = data[index]?.[topKey] === 0;

    return (
      <text
        x={Number(x) + Number(width) / 2}
        y={Number(y) - 5}
        textAnchor='middle'
        className={isTop ? 'fill-ctx-content-base' : 'fill-ctx-content-titleAlternative'}
      >
        {value}
      </text>
    );
  };

/** Esconde o rótulo "0" do segmento de cima que não tem altura. */
export const hideZeroLabel = (value: unknown) => (value === 0 ? '' : String(value));
